import {Analytics, getAnalytics, isSupported} from 'firebase/analytics';
import {firebaseApp} from './firebase';

let analyticsPromise: Promise<Analytics | null> | undefined;

// `isSupported()` returns false in environments where Analytics can't run
// (some Capacitor WebViews, browsers without IndexedDB, etc.). Cache the
// promise so initialization happens at most once.
export const getAnalyticsInstance = (): Promise<Analytics | null> => {
    if (!analyticsPromise) {
        analyticsPromise = isSupported()
            .then(supported => (supported ? getAnalytics(firebaseApp) : null))
            .catch(() => null);
    }
    return analyticsPromise;
};
